import React, { useState, type ReactNode } from 'react'
import classNames from 'classnames'
import styles from './OnboardingStepWrapper.module.scss'

export interface OnboardingStepItemProps {
  icon: ReactNode
  title: string
  description: string
  isCompleted: boolean
  isSkipped?: boolean
  isLast?: boolean
  id?: string
  children: ReactNode
}

export const OnboardingStepWrapper: React.FC<OnboardingStepItemProps> = ({
  icon,
  title,
  description,
  isCompleted,
  isSkipped,
  isLast = false,
  id,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(!isCompleted && !isSkipped)
  const [prevIsSkipped, setPrevIsSkipped] = useState(isSkipped)
  const [prevIsCompleted, setPrevIsCompleted] = useState(isCompleted)

  if (isSkipped !== prevIsSkipped || isCompleted !== prevIsCompleted) {
    setPrevIsSkipped(isSkipped)
    setPrevIsCompleted(isCompleted)
    if (isSkipped || isCompleted) {
      setIsOpen(false)
    }
  }

  return (
    <div id={id} className={classNames(styles.item, 'd-flex align-items-start')}>
      <div className={classNames(styles.rail, 'd-flex flex-column align-items-center align-self-stretch flex-shrink-0')}>
        <div className={classNames(styles.railIcon, 'd-flex align-items-center justify-content-center flex-shrink-0 lh-1 text-dark')}>
          {isCompleted ? <i className={classNames(styles.checkIcon, 'bi bi-check-circle')} /> : icon}
        </div>
        {!isLast ? <div className={styles.connector} /> : null}
      </div>
      <div className={classNames(styles.body, 'd-flex flex-column pb-4')}>
        <button
          type='button'
          className={classNames(styles.trigger, 'd-flex flex-column gap-1 w-100 bg-transparent border-0 p-0 text-start')}
          onClick={() => setIsOpen((prev) => !prev)}
          aria-expanded={isOpen}
        >
          <div className='d-flex align-items-center gap-2'>
            <p className={classNames(styles.title, 'fw-bold text-dark m-0 text-start')}>{title}</p>
            <i className={classNames(styles.chevron, 'bi bi-chevron-expand flex-shrink-0 text-secondary')} />
          </div>
          {!isOpen ? <p className={classNames(styles.description, 'fw-medium text-secondary m-0 text-start')}>{description}</p> : null}
        </button>
        {isOpen ? <div className={classNames(styles.content, 'overflow-hidden')}>{children}</div> : null}
      </div>
    </div>
  )
}
